/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Image, Transformer } from 'react-konva';

const KonvaImage = props => {
  const { src, shapeProps, isSelected, onSelect, onChange, draggable } = props;
  const [image, setImage] = useState(null);
  const imageRef = useRef(null);

  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    loadImage();
    return () => {
      if (imageRef.current) {
        imageRef.current.removeEventListener('load', handleLoad);
      }
    }
  }, []);

  useEffect(() => {
    loadImage();
  }, [src]);

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const loadImage = () => {
    const img = new window.Image();
    img.src = src;
    // img.crossOrigin = 'Anonymous';
    imageRef.current = img;
    imageRef.current.addEventListener('load', handleLoad);
  };

  const handleLoad = () => {
    setImage(imageRef.current);
  };

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      width: node.width() * scaleX,
      height: node.height() * scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Image
        image={image}
        draggable={draggable}
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        {...shapeProps}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      />
      { draggable && isSelected && <Transformer ref={trRef} shouldOverdrawWholeArea={true} />}
    </>
  );
};

export default KonvaImage;

KonvaImage.propTypes = {
  src: PropTypes.string.isRequired,
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
};

KonvaImage.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
